import { TReasoningEffort } from '../types/TReasoningEffort';
import { REASONING_EFFORTS } from './isReasoningEffort';

const OPENAI_MODEL_PATTERN = /^(gpt-|o\d)/;
const OPENROUTER_MODEL_PREFIX = 'or-';
const ANTHROPIC_MODEL_PATTERN = /claude|^bedrock\//;

export const getSupportedReasoningEfforts = (model: string): readonly TReasoningEffort[] => {
  if (!model || OPENAI_MODEL_PATTERN.test(model)) {
    return REASONING_EFFORTS;
  }

  if (ANTHROPIC_MODEL_PATTERN.test(model)) {
    return [];
  }

  if (model.startsWith(OPENROUTER_MODEL_PREFIX)) {
    return REASONING_EFFORTS.filter((effort) => effort !== 'none');
  }

  return [];
};
